import { AdminPortal } from '@frontegg/nextjs';
import {
  IconAdjustments,
  IconLogout,
  IconTable,
  IconUser,
  IconUserCog,
} from '@tabler/icons-react';
import { Avatar, getInitials } from '@zorro/design-system/v2/Avatar';
import { Card } from '@zorro/design-system/v2/Card';
import { Menu } from '@zorro/design-system/v2/Menu';
import { Group } from '@zorro/web/design-system';
import { useAppRouter, useImpersonation, useRoles } from '@zorro/web/ui-utils';

import { logout } from '../AppLayoutUtils';
import { AppLayoutHeaderMenuLogo } from './AppLayoutHeaderMenuLogo';

type Props = {
  withDonElenaMenuItems: boolean;
  isDon: boolean;
  isDiscoveryShopping: boolean;
};

export const AppLayoutHeaderMenu = ({
  withDonElenaMenuItems,
  isDon,
  isDiscoveryShopping,
}: Props) => {
  const { navigateToRoute } = useAppRouter();

  const { user, isImpersonated } = useImpersonation();
  const { isAgencyAdmin, isEmployerAdmin } = useRoles();

  if (!user) {
    return null;
  }

  return (
    <Menu size="sm">
      <Menu.Target>
        <Card
          variant={isDiscoveryShopping ? 'white' : 'white-border'}
          radius={isDiscoveryShopping ? 'md' : 'xs'}
          py="xs"
          px="sm"
          style={{ cursor: 'pointer' }}
        >
          <Group gap="sm" wrap="nowrap">
            <AppLayoutHeaderMenuLogo />
            <Avatar src={user.profilePictureUrl}>
              {getInitials(user.firstName, user.lastName)}
            </Avatar>
          </Group>
        </Card>
      </Menu.Target>
      <Menu.Dropdown>
        {withDonElenaMenuItems && (
          <>
            {isDon ? (
              <Menu.Item
                leftSection={<IconUser size={16} stroke={1.25} />}
                onClick={() => navigateToRoute('HOME', [])}
              >
                Personal view
              </Menu.Item>
            ) : (
              <Menu.Item
                leftSection={<IconTable size={16} stroke={1.25} />}
                onClick={() => navigateToRoute('DON_COMPANY', [])}
              >
                Admin view
              </Menu.Item>
            )}
            <Menu.Divider />
          </>
        )}
        {!isImpersonated && (
          <Menu.Item
            leftSection={<IconUserCog size={16} stroke={1.25} />}
            onClick={() => AdminPortal.show()}
          >
            My settings
          </Menu.Item>
        )}
        {isAgencyAdmin && (
          <Menu.Item
            leftSection={<IconAdjustments size={16} stroke={1.25} />}
            onClick={() => navigateToRoute('OPS_AGENCY', [user.tenantId])}
          >
            Agency setup
          </Menu.Item>
        )}
        {isEmployerAdmin && (
          <Menu.Item
            leftSection={<IconAdjustments size={16} stroke={1.25} />}
            onClick={() =>
              navigateToRoute('DON_COMPANY_SETUP_COMPANY_DETAILS', [
                user.tenantId,
              ])
            }
          >
            Company setup
          </Menu.Item>
        )}
        <Menu.Item
          leftSection={<IconLogout size={16} stroke={1.25} />}
          onClick={logout}
        >
          Log out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
